import {
  IElementsById,
  IElementsEventDataById,
} from "core-integration/src/store/elements/types";
import { IPickLight } from "core-integration/src/store/entries/types";
import { IFixture } from "core-integration/src/store/fixtures/types";
import { ITeamsById } from "core-integration/src/store/teams/types";
import React from "react";
import { integerDivide } from "../../utils/points";
import FixtureForElement from "../FixtureForElement";

const valueForPlayerElement =
  (initProps: {
    elementsById: IElementsById;
    elementsDataById: IElementsEventDataById | null;
    fixturesById: Record<string, IFixture> | null;
    teamsById: ITeamsById;
  }) =>
  (pick: IPickLight) => {
    if (!initProps.elementsDataById || !initProps.fixturesById) {
      return null;
    }
    const element = initProps.elementsById[pick.element];
    const elementData = initProps.elementsDataById[element.id];
    const fragments: React.ReactNode[] = [];
    let started = 0;
    elementData.explain.forEach((e) => {
      const fixture = initProps.fixturesById![e.fixture];
      if (!fixture.started) {
        fragments.push(
          <FixtureForElement
            element={element}
            fixture={fixture}
            teamsById={initProps.teamsById}
          />,
        );
      } else {
        started++;
      }
    });
    if (started) {
      fragments.unshift(
        integerDivide(
          elementData.stats.total_points * Math.max(pick.multiplier, 1),
          10,
        ),
      );
    }
    return fragments.length ? (
      fragments.reduce((result, item) => (
        <>
          {result}
          {", "}
          {item}
        </>
      ))
    ) : (
      <span>-</span>
    );
  };

export default valueForPlayerElement;
